import React, { useEffect } from 'react';
import Image from 'next/image';
import styles from "./landing.module.scss"
import logo from '../../../../public/images/logo.png';
import bgImage from '../../../../public/images/home-section1.jpg';
import float1 from '../../../../public/images/bg-float1.png';
import float2 from '../../../../public/images/bg-float2.png';
import float3 from '../../../../public/images/bg-float3.png';
import bgMask from '../../../../public/images/bg-mask1.jpg';
import LandingBg from '../landingBg';
import { gsap } from 'gsap/dist/gsap';
// Import Swiper Use
import { useSwiper, useSwiperSlide } from 'swiper/react';
import TextSplit from '../../split-text';
// Page Musics
import playClick from '../../actions/default-click';
import playHover from '../../actions/default-hover';
import Arrow from '../../icons/arrow';

// Mobile Assets
import mbMask from '../../../../public/images/mobile/bg-mask.jpg'
import mbImage from '../../../../public/images/mobile/landing-bg.jpg'

function Landing(isActive) {
    const swiperSlide = useSwiperSlide();

    const screenWidth = window.innerWidth;
    let pageMask = screenWidth < 767 ? mbMask : bgMask;
    let pageImage = screenWidth < 767 ? mbImage : bgImage;

    const pageData = {
        bgData: {
            bgImage: pageImage,
            float1: float1,
            float2: float2,
            float3: float3,
            bgMask: pageMask,
        },
        title: "במסתרים",
        subtitle: "סיפורם של ילדי מסתור בתקופת השואה"
    }
    
    // Swiper 
    const swiper = useSwiper();
    //console.log(swiperSlide.isActive);

    // GSAP Split text
    useEffect(() => {  
        //gsap.set('.logo', {y: 100, opacity: 0}); 
        gsap.set('.title', {y: 100, opacity: 0}); 
        gsap.set('.subtitle', {y: 100, opacity: 0});   
        gsap.set('.next-section', {y: 100, opacity: 0});
        if(document.querySelector('.mobileToaster')) {
            gsap.set('.mobileToaster', {y: 100, opacity: 0});
        }
        //const tl = gsap.timeline(); 
        //gsap.to('.logo', {y:0, opacity: 1, ease:"ease.in", duration: 1, delay: 2})
        gsap.to('.title', {y:0, opacity: 1, ease:"ease.out", duration: 1, delay: 2.2 })
        gsap.to('.subtitle', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay: 2.4 })
        gsap.to('.next-section', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay: 2.6 });
        if(document.querySelector('.mobileToaster')) {
            gsap.to('.mobileToaster', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay: 2.7 });
        }
        //tl.restart();
    }, [swiperSlide.isActive]);

  return (
    <>
        <LandingBg data={pageData.bgData} />
        <div id="landing" className={`landing-wrapper m-auto relative z-20 text-center ${styles.landing}`}>
            <Image 
            width={logo.width}
            height={logo.height}
            className={`logo inline-block ${styles.logo}`} 
            src={logo.src} 
            alt="םירתסמב" />

            <TextSplit 
            tag={'h1'}
            className={`title title-font text-white ${styles.title}`}
            data={pageData.title} />

            <h2 
            className={`subtitle title-font text-5xl ${styles.subtitle}`}>{pageData.subtitle}</h2>
            
            <div className={`next-section relative text-white inline-block ${styles.magnetic}`}>
                <button 
                onClick={() => {
                    swiper.slideNext()
                    playClick();
                }}
                onMouseEnter={() => {
                    playHover();
                }}
                className={`ml-auto mr-auto flex justify-center items-center ${styles.button}`}>
                    {screenWidth < 767 && <span className={styles.text}>להתנסות</span>}
                    <span className={`flex items-center justify-center bg-white w-12 h-12 md:w-10 md:h-10 text-center rounded-full ${styles.icon}`}>
                        <Arrow />
                    </span>
                </button>
            </div>

            {screenWidth < 767 && (
            <div className={`mobileToaster ${styles.mobileToaster}`}>
                <div className={`${styles.toasterContent}`}>
                    <p>התערוכה המלאה לא זמינה בטלפון נייד,<br/>עברו למסך מחשב והתחילו לגלות</p>
                </div>
                <button 
                onClick={() => {
                    if (navigator.share) {
                        navigator.share({
                            title: `'במסתרים׳ ילדי מסתור בתקופת השואה. תערוכה וירטואלית.`,
                            text: 'גנזך קידוש השם מציגים: חוויה אינטראקטיבית על ילדי מסתור בתקופת השואה. למדו על פרידתם מההורים, המסתור, ההצלה והשיקום לאחר המלחמה. מותאם לבני נוער. התחילו בסיור.',
                            url: 'https://ganzach.org.il/',
                        })
                        .then(() => console.log('Successful share'))
                        .catch((error) => console.log('Error sharing', error));
                    } else {
                        console.log('Share not supported on this browser, do it the old way.');
                    }
                }}
                className={styles.toasterButton}>שלחו לי קישור למייל או לוואטסאפ</button>
            </div>
            )}
        </div>
    </>
  )
}

export default Landing